import { ScaleData } from '@checklistfacil/shared/util/item-scale';

export interface DependencyItemCard {
  hasScaleIcons: boolean;
  name: string;
  scaleText?: string;
  scaleIcons?: ScaleData;
}
